import type { MailboxInfo } from "owa-client-types";
import { getAllAsyncItemEntries } from "owa-copilot-async-chat-store";
import type { AsyncItemEntry, AsyncTaskState } from "owa-copilot-async-chat-types";
import { getAsyncTaskState } from "../utils/getAsyncTaskState";

/** An async item paired with the app-facing state it surfaces as. */
export interface SurfacedAsyncItem {
    entry: AsyncItemEntry;
    state: AsyncTaskState;
}

/**
 * The async items surfaced for an account: those whose status maps to a real state (dropping
 * None/Canceled) and are still unread. Single source of the inclusion rule, so the Tasks pane's
 * section lists and every status count are always derived the same way.
 */
export function getSurfacedAsyncItems(mailboxInfo: MailboxInfo): SurfacedAsyncItem[] {
    const items: SurfacedAsyncItem[] = [];
    for (const entry of getAllAsyncItemEntries(mailboxInfo)) {
        const state = getAsyncTaskState(entry.status);
        if (state === undefined || !entry.isUnread) {
            continue;
        }
        items.push({ entry, state });
    }
    return items;
}
